import React, { useState } from "react";

export default function BuildingNavigator() {
	
	
	const [activeFloor, setActiveFloor] = useState("Ground");

	  const floors = ["Ground", "Level 1", "Level 2", "Level 3"];
	
	// 🔥 FLOATING CONTROL PANEL
	 const floatingPanel = {
	   position: "fixed",
	   top: "80px",
	   right: "20px",
	   display: "flex",
	   flexDirection: "column",
	   alignItems: "center",
	   gap: "10px",
	   zIndex: 100
	 };

	 const buildingOrb = {
	   width: "70px",
	   height: "70px",
	   borderRadius: "50%",
	   overflow: "hidden",
	   border: "2px solid #5a9bd6",
	   boxShadow: "0 6px 16px rgba(0,0,0,0.4)",
	   cursor: "pointer",
	   transition: "all 0.2s ease"
	 };

	 const floorPill = (active) => ({
	   padding: "6px 14px",
	   borderRadius: "20px",
	   fontSize: "12px",
	   cursor: "pointer",
	   background: active ? "#5a9bd6" : "rgba(0,0,0,0.5)",
	   color: active ? "#fff" : "#ddd",
	   backdropFilter: "blur(6px)",
	   transition: "all 0.2s ease",
	   border: active ? "none" : "1px solid rgba(255,255,255,0.1)"
	 });
	
	   return (
	         <div style={floatingPanel}>

	           {/* 🏢 BUILDING ORB */}
	           <div
	             style={buildingOrb}
	           >
	             <img
	               src="/matterportimages/building.jpg"
	               style={{ width: "100%", height: "100%", objectFit: "cover" }}
	             />
	           </div>

	           {/* 🏢 FLOORS */}
	           {floors.map(f => (
	             <div
	               key={f}
	               style={floorPill(activeFloor === f)}
	               onClick={() => setActiveFloor(f)}
	             >
	               {f}
	             </div>
	           ))}

	         </div>
		
	   );
}